import { render, staticRenderFns } from "./doi.vue?vue&type=template&id=31c11db5&scoped=true"
import script from "./doi.vue?vue&type=script&lang=js"
export * from "./doi.vue?vue&type=script&lang=js"
import style0 from "./doi.vue?vue&type=style&index=0&id=31c11db5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c11db5",
  null
  
)

export default component.exports